<template>
	<div class="nav empty-list-message">
		<EmptyLLImg class="empty-list-message__img" />
		<div class="empty-list-message__text">
			{{ labelText }}
		</div>
	</div>
</template>

<script>
import EmptyLLImg from '@/assets/empty-LL.svg?inline';

export default {
	name: 'VueNotificationEmptyListMessage',
	components: {
		EmptyLLImg
	},
	props: {
		labelText: {
			type: String,
			default: ''
		}
	}
};
</script>

<style lang="scss" scoped>
.empty-list-message {
	display: flex;
	flex-direction: column;
	align-items: center;
	margin: 92px 0;
	padding: $padding-sm;
	background: var(--bg-0);
	color: var(--bg-0-fg-4);

	&__img {
		max-width: 175px;
		margin-bottom: $gutter-xl;
	}

	&__text {
		@include heading(sm);
	}
}
</style>
